import { isMacLike } from "@/utils/platform";
import { useCallback, useEffect } from "react";

/**
 * Enables platform-specific Cmd+O (or Ctrl+O) to change the state of a modal
 */
export const useNewEnvironmentShortcut = (setTriggered: (value: boolean) => void) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "o") {
                return;
            }
            if (isMacLike() ? event.metaKey : event.ctrlKey) {
                if (event.defaultPrevented) {
                    return;
                }
                event.preventDefault();
                setTriggered(true);
            }
        },
        [setTriggered],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
